var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 24.9261C19.5697 24.9261 24.9154 19.5804 24.9154 13.0095C24.261 -2.7996 1.7342 -2.79527 1.08203 13.0095C1.08203 19.5804 6.42774 24.9261 12.9987 24.9261Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6138 11.0016C10.237 13.4608 10.2392 12.56 12.6138 15.017C12.8256 15.2288 13.168 15.2288 13.3798 15.017L15.0048 13.3925C15.2144 13.191 15.2149 12.8281 15.0048 12.6266L13.3798 11.0016C13.168 10.7898 12.8256 10.7898 12.6138 11.0016Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36587 12.3095C9.569 12.5127 9.92867 12.5127 10.1318 12.3095L12.9988 9.44248L15.8659 12.3095C16.0674 12.5192 16.4303 12.5197 16.6318 12.3095L18.2568 10.6845C18.4686 10.4727 18.4686 10.1304 18.2568 9.91861L13.3818 5.04361C13.17 4.83182 12.8277 4.83182 12.6159 5.04361L7.74088 9.91861C7.52908 10.1304 7.52908 10.4727 7.74088 10.6845L9.36587 12.3095Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9663 12.6259C18.5071 10.2502 19.4085 10.2518 16.9504 12.6259C16.7408 12.8274 16.7402 13.1903 16.9504 13.3918L18.5754 15.0168C18.7872 15.2286 19.1295 15.2286 19.3413 15.0168L20.9663 13.3918C21.1759 13.1903 21.1765 12.8274 20.9663 12.6259Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03242 12.6259C7.49159 10.2502 6.59026 10.2518 9.04834 12.6259C9.25796 12.8274 9.25851 13.1903 9.04834 13.3918L7.42334 15.0168C7.21155 15.2286 6.86921 15.2286 6.65742 15.0168L5.03242 13.3918C4.8228 13.1903 4.82226 12.8274 5.03242 12.6259Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6318 13.7102C16.4287 13.507 16.069 13.507 15.8659 13.7102L12.9988 16.5772L10.1318 13.7102C9.93029 13.5005 9.56737 13.5 9.36587 13.7102L7.74088 15.3352C7.52908 15.5469 7.52908 15.8893 7.74088 16.1011L12.6159 20.9761C12.8277 21.1879 13.17 21.1879 13.3818 20.9761L18.2568 16.1011C18.4686 15.8893 18.4686 15.5469 18.2568 15.3352L16.6318 13.7102Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.91b5a2fa8ccacbd39abf23f7781f39ed.svg";
export { ForwardRef as ReactComponent };